module.exports = __webpack_public_path__ + "static/media/hotdoc1.7c9b58c3.png";